import { c as _c } from "react/compiler-runtime";
import { faTimes, faChevronDown, faTableLayout
// faGrid,
} from '@fortawesome/pro-regular-svg-icons';
import { faGrid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { CroppedText, Text } from 'shared/typography';
import Button from '../button';
import { Box, Flex, Grid } from '../grid';
import ScrollTabs from '../scroll-tabs';
import { Heading } from '../typography';
import Modal_, { ModalProps, ModalWindowProps } from './component';
import { useMedia } from '../hooks/use-media';
import { useTheme } from '@emotion/react';
import DropdownSelect from '../dropdown-select';
const nope = () => false;
export const withCloseWarning = (Component: React.ComponentType<any>) =>
// eslint-disable-next-line react/display-name
({
  close,
  hasUnsavedChanges,
  // = nope,
  ...props
}: {
  close: () => void;
  hasUnsavedChanges: boolean | (() => boolean);
} & any) => {
  const [warningVisible, setWarningVisible] = React.useState(false);
  const checkedClose = React.useCallback((skipCheck = false) => {
    function after(dirty) {
      if (dirty) {
        setWarningVisible(true);
      } else {
        if (close) {
          close();
        }
        setWarningVisible(false);
      }
    }
    const result = skipCheck !== true && (typeof hasUnsavedChanges === 'function' ? hasUnsavedChanges() : hasUnsavedChanges);
    if (result?.then) {
      result.then(dirty => after(dirty));
    } else {
      after(result);
    }
  }, [close, hasUnsavedChanges]);
  const dismiss = React.useCallback(() => {
    if (close) {
      close();
    }
    setWarningVisible(false);
  }, [close]);
  return <>
        <Component {...props} close={close && checkedClose} />
        <Modal_ isOpen={warningVisible} close={() => setWarningVisible(false)}>
          {() => <>
              <ModalHeader close={() => setWarningVisible(false)} title="Unsaved changes" type="alert" />

              <Grid p={4}>
                <CroppedText>
                  You have unsaved changes. Would you like to discard them?
                </CroppedText>

                <Flex justifyContent="flex-end" mt={3}>
                  <Button mr={2} variant="flat" color="gray" onClick={() => setWarningVisible(false)}>
                    Back
                  </Button>

                  <Button color="alert" className="confirm-button" onClick={dismiss}>
                    Discard changes
                  </Button>
                </Flex>
              </Grid>
            </>}
        </Modal_>
      </>;
};
export function CloseButton(t0) {
  const $ = _c(16);
  let onClick;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      ref: t1,
      onClick,
      isDark: t2,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = onClick;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
  } else {
    onClick = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const ref = t1 === undefined ? null : t1;
  const isDark = t2 === undefined ? false : t2;
  const t3 = isDark ? "text" : "white";
  const t4 = isDark ? "gray.6" : "gray.1";
  let t5;
  if ($[5] !== t4) {
    t5 = {
      color: t4
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = {
      cursor: "pointer",
      color: t3,
      fontSize: "16px",
      "&:hover, &:active": t5
    };
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FontAwesomeIcon size="lg" icon={faTimes} />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onClick || $[12] !== ref || $[13] !== rest || $[14] !== t6) {
    t8 = <Box ref={ref} as="button" type="button" className="close" onClick={onClick} tabIndex={-1} sx={t6} {...rest}>{t7}</Box>;
    $[11] = onClick;
    $[12] = ref;
    $[13] = rest;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
interface ModalHeaderProps {
  close?: () => void;
  title: React.ReactNode;
  tabs?: React.ReactNode;
  rightCornerTrigger?: React.ReactNode;
  type?: string;
  leftCorner?: React.ReactNode;
  rightCorner?: React.ReactNode;
  leftTitle?: boolean;
  changeSize?: (size: ModalWindowProps['size']) => void;
  size?: ModalWindowProps['size'];
  sizeOptions?: ModalWindowProps['size'][];
}
const sizeToString = (size: ModalWindowProps['size']) => {
  const sizeMap = {
    tiny: 'Tiny window',
    small: 'Small window',
    medium: 'Medium window',
    large: 'Large window',
    xlarge: 'Extra Large window',
    full: 'Full Screen',
    minimized: 'Minimized',
    right: 'Right Side',
    left: 'Left Side'
  };
  return sizeMap[size] || '';
};
const ModalHeader_ = t0 => {
  const $ = _c(50);
  const {
    close,
    title,
    tabs: t1,
    rightCornerTrigger: t2,
    type: t3,
    leftCorner: t4,
    rightCorner: t5,
    leftTitle: t6,
    size: t7,
    sizeOptions: t8,
    changeSize: t9
  } = t0;
  const tabs = t1 === undefined ? null : t1;
  const rightCornerTrigger = t2 === undefined ? null : t2;
  t3 === undefined ? "" : t3;
  const leftCorner = t4 === undefined ? null : t4;
  const rightCorner = t5 === undefined ? null : t5;
  const leftTitle = t6 === undefined ? false : t6;
  t7 === undefined ? null : t7;
  let t10;
  if ($[0] !== t8) {
    t10 = t8 === undefined ? [] : t8;
    $[0] = t8;
    $[1] = t10;
  } else {
    t10 = $[1];
  }
  const sizeOptions = t10;
  const changeSize = t9 === undefined ? null : t9;
  const [rightCornerOpen, setRightCornerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMedia(theme.mediaQueries.mediumDown);
  let t11;
  let t12;
  if ($[2] !== isMobile || $[3] !== rightCornerOpen) {
    t11 = () => {
      if (!isMobile && rightCornerOpen) {
        setRightCornerOpen(false);
      }
    };
    t12 = [isMobile, rightCornerOpen];
    $[2] = isMobile;
    $[3] = rightCornerOpen;
    $[4] = t11;
    $[5] = t12;
  } else {
    t11 = $[4];
    t12 = $[5];
  }
  React.useEffect(t11, t12);
  const rightCornerLabel = rightCornerOpen ? "Less" : "More";
  const t13 = leftTitle ? "space-between" : "center";
  let t14;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      position: "relative",
      gap: 2
    };
    $[6] = t14;
  } else {
    t14 = $[6];
  }
  let t15;
  if ($[7] !== changeSize || $[8] !== leftCorner || $[9] !== sizeOptions) {
    t15 = (leftCorner || changeSize) && <Box>{changeSize && <DropdownSelect value={null} onChange={newSize => changeSize(newSize)} items={sizeOptions.map(_temp)} itemToString={_temp2} renderToggle={_temp3} />}{leftCorner && <Flex alignItems="center">{leftCorner}</Flex>}</Box>;
    $[7] = changeSize;
    $[8] = leftCorner;
    $[9] = sizeOptions;
    $[10] = t15;
  } else {
    t15 = $[10];
  }
  const t16 = leftTitle ? "flex-start" : "center";
  let t17;
  if ($[11] !== leftTitle || $[12] !== rightCornerTrigger) {
    t17 = leftTitle ? rightCornerTrigger ? ["70%", "50%"] : ["50%", "50%"] : "";
    $[11] = leftTitle;
    $[12] = rightCornerTrigger;
    $[13] = t17;
  } else {
    t17 = $[13];
  }
  const t18 = leftTitle ? 0 : 4;
  let t19;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      overflow: "hidden",
      display: "-webkit-box",
      WebkitLineClamp: 1,
      WebkitBoxOrient: "vertical",
      overflowWrap: "break-word"
    };
    $[14] = t19;
  } else {
    t19 = $[14];
  }
  let t20;
  if ($[15] !== t18 || $[16] !== title) {
    t20 = <Heading fontSize={3} as="div" px={t18} sx={t19}>{title}</Heading>;
    $[15] = t18;
    $[16] = title;
    $[17] = t20;
  } else {
    t20 = $[17];
  }
  let t21;
  if ($[18] !== t16 || $[19] !== t17 || $[20] !== t20) {
    t21 = <Flex justifyContent={t16} py={4} flexGrow={1} maxWidth={t17}>{t20}</Flex>;
    $[18] = t16;
    $[19] = t17;
    $[20] = t20;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  let t22;
  if ($[22] !== rightCorner || $[23] !== rightCornerTrigger) {
    t22 = rightCorner && <Box mr={2} display={[rightCornerTrigger ? "none" : "flex", "flex"]}>{rightCorner}</Box>;
    $[22] = rightCorner;
    $[23] = rightCornerTrigger;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  let t23;
  if ($[25] !== rightCornerLabel || $[26] !== rightCornerOpen || $[27] !== rightCornerTrigger) {
    t23 = rightCornerTrigger && <Box mr={2}><Box as="button" sx={{
        background: "none",
        border: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
      }} onClick={() => setRightCornerOpen(_temp4)}><Flex display={["flex", "none"]} alignItems="center" sx={{
          gridGap: 2
        }} pr={["30px", 0]}>{rightCornerTrigger}<Text width="34px" textAlign="right">{rightCornerLabel}</Text><Box sx={{
            transition: "transform 0.2s",
            color: "gray.6",
            transform: rightCornerOpen ? "rotate(180deg)" : "rotate(0deg)"
          }}><FontAwesomeIcon size="sm" icon={faChevronDown} /></Box></Flex></Box></Box>;
    $[25] = rightCornerLabel;
    $[26] = rightCornerOpen;
    $[27] = rightCornerTrigger;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  let t24;
  if ($[29] !== close) {
    t24 = close && <CloseButton isDark={true} onClick={close} />;
    $[29] = close;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] !== t22 || $[32] !== t23 || $[33] !== t24) {
    t25 = <Flex alignItems="center" py={4} mr={0}>{t22}{t23}{t24}</Flex>;
    $[31] = t22;
    $[32] = t23;
    $[33] = t24;
    $[34] = t25;
  } else {
    t25 = $[34];
  }
  let t26;
  if ($[35] !== t13 || $[36] !== t15 || $[37] !== t21 || $[38] !== t25) {
    t26 = <Flex justifyContent={t13} alignItems="center" className="header" px={5} flexWrap="nowrap" sx={t14} minHeight="50px">{t15}{t21}{t25}</Flex>;
    $[35] = t13;
    $[36] = t15;
    $[37] = t21;
    $[38] = t25;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] !== tabs) {
    t27 = tabs && <Box flex="1 1 auto" overflow="hidden" mb="-1px" alignSelf="flex-end">{tabs}</Box>;
    $[40] = tabs;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== rightCorner || $[43] !== rightCornerOpen || $[44] !== rightCornerTrigger) {
    t28 = rightCornerTrigger && <Box flex="1 1 auto" alignSelf="flex-end" backgroundColor="bodyBackground" sx={{
      display: ["block", "none"],
      height: rightCornerOpen ? "auto" : 0,
      overflow: "hidden",
      paddingTop: rightCornerOpen ? 3 : 0,
      paddingBottom: rightCornerOpen ? 3 : 0,
      paddingX: 4,
      transition: "height 0.8s cubic-bezier(.4,0,.2,1), padding-top 0.4s cubic-bezier(.4,0,.2,1), padding-bottom 0.4s cubic-bezier(.4,0,.2,1)"
    }}>{rightCorner}</Box>;
    $[42] = rightCorner;
    $[43] = rightCornerOpen;
    $[44] = rightCornerTrigger;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  let t29;
  if ($[46] !== t26 || $[47] !== t27 || $[48] !== t28) {
    t29 = <Box borderBottomStyle="solid" borderBottomColor="borderColor" borderBottomWidth="1px">{t26}{t27}{t28}</Box>;
    $[46] = t26;
    $[47] = t27;
    $[48] = t28;
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  return t29;
};
export const ModalHeader = withCloseWarning(ModalHeader_);
const Modal = withCloseWarning(Modal_);
export default Modal;
interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  close?: () => void;
  className?: string;
  type?: string;
  onConfirm?: () => Promise<any> | void;
  confirmText?: string;
  dismissText?: string;
  leftOfButtons?: string | React.ReactElement | React.JSX.Element;
  children;
  zIndexDelta?: number;
}
export const ConfirmModal = t0 => {
  const $ = _c(19);
  const {
    isOpen,
    title,
    close,
    className: t1,
    type: t2,
    zIndexDelta: t3,
    onConfirm: t4,
    confirmText: t5,
    dismissText: t6,
    leftOfButtons: t7,
    children
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const type = t2 === undefined ? "" : t2;
  const zIndexDelta = t3 === undefined ? 0 : t3;
  const onConfirm = t4 === undefined ? Promise.resolve : t4;
  const confirmText = t5 === undefined ? "" : t5;
  const dismissText = t6 === undefined ? "" : t6;
  const leftOfButtons = t7 === undefined ? null : t7;
  const [isLoading, setIsLoading] = React.useState(false);
  let t8;
  let t9;
  if ($[0] !== isOpen) {
    t8 = () => {
      if (!isOpen) {
        setIsLoading(false);
      }
    };
    t9 = [isOpen];
    $[0] = isOpen;
    $[1] = t8;
    $[2] = t9;
  } else {
    t8 = $[1];
    t9 = $[2];
  }
  React.useEffect(t8, t9);
  const t10 = `${className} ${type}`;
  let t11;
  if ($[3] !== children || $[4] !== close || $[5] !== confirmText || $[6] !== dismissText || $[7] !== isLoading || $[8] !== leftOfButtons || $[9] !== onConfirm || $[10] !== title || $[11] !== type) {
    t11 = () => <><ModalHeader_ close={close} title={title} type={type} /><Grid p={4}><Box>{children}</Box><Flex justifyContent="space-between" mt={3}><Box>{leftOfButtons}</Box><Flex>{dismissText && <Button mr={2} variant="flat" color="gray" onClick={close}>{dismissText || "No"}</Button>}<Button color={type || "primary"} className="confirm-button" loading={isLoading} disabled={isLoading} onClick={() => {
              const result = onConfirm();
              if (result && result.then) {
                setIsLoading(true);
                result.then(() => {
                  setIsLoading(false);
                }).catch(() => {
                  setIsLoading(false);
                });
              }
            }}>{confirmText || "Yes"}</Button></Flex></Flex></Grid></>;
    $[3] = children;
    $[4] = close;
    $[5] = confirmText;
    $[6] = dismissText;
    $[7] = isLoading;
    $[8] = leftOfButtons;
    $[9] = onConfirm;
    $[10] = title;
    $[11] = type;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== close || $[14] !== isOpen || $[15] !== t10 || $[16] !== t11 || $[17] !== zIndexDelta) {
    t12 = <Modal isOpen={isOpen} close={close} className={t10} zIndexDelta={zIndexDelta}>{t11}</Modal>;
    $[13] = close;
    $[14] = isOpen;
    $[15] = t10;
    $[16] = t11;
    $[17] = zIndexDelta;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};
export const StandardModal = t0 => {
  const $ = _c(25);
  let children;
  let close;
  let isOpen;
  let rest;
  let t1;
  let t2;
  let t3;
  let t4;
  let title;
  if ($[0] !== t0) {
    ({
      isOpen,
      title,
      close,
      leftCorner: t1,
      rightCorner: t2,
      hasUnsavedChanges: t3,
      children,
      leftTitle: t4,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = close;
    $[3] = isOpen;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = title;
  } else {
    children = $[1];
    close = $[2];
    isOpen = $[3];
    rest = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    title = $[9];
  }
  const leftCorner = t1 === undefined ? null : t1;
  const rightCorner = t2 === undefined ? null : t2;
  const hasUnsavedChanges = t3 === undefined ? nope : t3;
  const leftTitle = t4 === undefined ? false : t4;
  let t5;
  if ($[10] !== children || $[11] !== leftCorner || $[12] !== leftTitle || $[13] !== rest.changeSize || $[14] !== rest.size || $[15] !== rest.sizeOptions || $[16] !== rightCorner || $[17] !== title) {
    t5 = props => <><ModalHeader title={title} close={props.close} leftCorner={leftCorner} rightCorner={rightCorner} leftTitle={leftTitle} changeSize={rest.changeSize} sizeOptions={rest.sizeOptions} size={rest.size} /><Grid p={6}>{children({
          ...props
        })}</Grid></>;
    $[10] = children;
    $[11] = leftCorner;
    $[12] = leftTitle;
    $[13] = rest.changeSize;
    $[14] = rest.size;
    $[15] = rest.sizeOptions;
    $[16] = rightCorner;
    $[17] = title;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== close || $[20] !== hasUnsavedChanges || $[21] !== isOpen || $[22] !== rest || $[23] !== t5) {
    t6 = <Modal isOpen={isOpen} close={close} hasUnsavedChanges={hasUnsavedChanges} {...rest}>{t5}</Modal>;
    $[19] = close;
    $[20] = hasUnsavedChanges;
    $[21] = isOpen;
    $[22] = rest;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
export const TabModal = t0 => {
  const $ = _c(26);
  let activeItem;
  let children;
  let className;
  let close;
  let isOpen;
  let items;
  let rest;
  let setActiveItem;
  let t1;
  let title;
  if ($[0] !== t0) {
    ({
      isOpen,
      title,
      close,
      hasUnsavedChanges: t1,
      children,
      activeItem,
      items,
      setActiveItem,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = activeItem;
    $[2] = children;
    $[3] = className;
    $[4] = close;
    $[5] = isOpen;
    $[6] = items;
    $[7] = rest;
    $[8] = setActiveItem;
    $[9] = t1;
    $[10] = title;
  } else {
    activeItem = $[1];
    children = $[2];
    className = $[3];
    close = $[4];
    isOpen = $[5];
    items = $[6];
    rest = $[7];
    setActiveItem = $[8];
    t1 = $[9];
    title = $[10];
  }
  const hasUnsavedChanges = t1 === undefined ? nope : t1;
  const t2 = `tab-modal ${className}`;
  let t3;
  if ($[11] !== activeItem || $[12] !== children || $[13] !== close || $[14] !== hasUnsavedChanges || $[15] !== items || $[16] !== setActiveItem || $[17] !== title) {
    t3 = props => <><ModalHeader title={title} close={close} hasUnsavedChanges={hasUnsavedChanges} tabs={<ScrollTabs rtl={true} activeItem={activeItem} items={items} setActiveItem={setActiveItem} />} /><Grid p={4}>{children({
          ...props,
          close
        })}</Grid></>;
    $[11] = activeItem;
    $[12] = children;
    $[13] = close;
    $[14] = hasUnsavedChanges;
    $[15] = items;
    $[16] = setActiveItem;
    $[17] = title;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== close || $[20] !== hasUnsavedChanges || $[21] !== isOpen || $[22] !== rest || $[23] !== t2 || $[24] !== t3) {
    t4 = <Modal isOpen={isOpen} close={close} className={t2} hasUnsavedChanges={hasUnsavedChanges} {...rest}>{t3}</Modal>;
    $[19] = close;
    $[20] = hasUnsavedChanges;
    $[21] = isOpen;
    $[22] = rest;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  return t4;
};
function _temp(size_0) {
  return {
    label: sizeToString(size_0),
    value: size_0
  };
}
function _temp2(item) {
  return "";
}
function _temp3(t0) {
  const {
    value,
    onClick,
    ...rest
  } = t0;
  return <Box {...rest} as="button" type="button" onClick={onClick} sx={{
    background: "none",
    border: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    cursor: "pointer"
  }} data-sentry-element="Box" data-sentry-component="_temp3" data-sentry-source-file="index.tsx"><Text fontSize={1} color="gray.6" mr={2} data-sentry-element="Text" data-sentry-source-file="index.tsx" data-sentry-element="Text"><FontAwesomeIcon icon={faGrid} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="index.tsx" data-sentry-element="FontAwesomeIcon" /></Text></Box>;
}
function _temp4(v) {
  return !v;
}